module.exports = __webpack_public_path__ + "static/media/title_team.caddf9ce.svg";